import _ from "lodash";
import React from "react";
import classes from "./ClassCard.scss";
import { colors } from "Constants";
import I18nHOC from "UIComponents/I18nHOC";
import { TickPlain } from "SvgComponents";
import classNames from "classnames";

const ClassCard = React.memo(props => {
  const {
    course,
    onClassSelect,
    showCount,
    containerStyle = {},
    t,
    showSelectedIcon,
    selected,
    isMapleBearLikeOrg = false,
    showSubText = false,
    subText,
  } = props;
  const { title, grades = [], id, isArchived } = course;

  const { globalGrade } = grades[0] || {};

  const color = _.get(globalGrade, "constants.color", "") || colors.blue400;

  const classCardContainerClasses = classNames(classes.container, {
    archivedBg: isArchived,
  });
  return (
    <div
      data-test-id={`button-course-${course?.id}`}
      className={classCardContainerClasses}
      onClick={() => onClassSelect(id, false, "classList")}
      style={{ borderLeftColor: color, ...containerStyle }}
    >
      <div className={classes.classLabel}>{`${title}`}</div>
      {showSelectedIcon && selected && (
        <div className={classes.icon} style={{ background: color }}>
          <TickPlain fill={colors.white} height={8} width={8} />
        </div>
      )}
      {!!showSubText && <span> {subText}</span>}
    </div>
  );
});

ClassCard.displayName = "ClassCard";
export default I18nHOC({ resource: ["teacherHomePage"] })(ClassCard);
